/*
 * @fileOverView Search component definition
 */

import Vue from 'vue';
import Search from 'components/modules/utility/search/search.mixin';
import { mapGetters } from 'vuex';

/**
 * Selectors used to alter elements as the location search is used.
 */
const SELECTORS = {
  'LIST_TITLE_SUFFIX': '.js-list-title-suffix'
}

/**
 * [Search Vue]
 * @type {class}
 */
Vue.component('search-places-vue', {
  mixins: [Search],

  computed: {
    ...mapGetters(['places/filter']),
    filterSearch() {
      return this['places/filter']().map(item => {
        return {
          "term": item,
          "url": '#'
        }
      });
    }
  },

  watch: {
    search: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$store.dispatch('places/setValue', this.search);
      }
    }
  },

  methods: {
    /**
     * Handles selection of an item from a click or keypress.
     *
     * @param {Object} event - Javascript event object
     */
    handleItemSelected(e) {
      e.preventDefault();
      this.search = e.target.innerText;
      this.updateDisplay();
    },

    /**
     * Handles the submission of the form when the submit button is clicked.
     *
     * @param {Object} event - Javascript event object
     */
    handleSubmit(e) {
      e.preventDefault();
      // Set the value to the first suggestion. Clear it if there aren't any.
      this.search = this.filterSearch.length ? this.filterSearch[0].term : '';
      this.updateDisplay();
    },

    /**
     * Updates visual elements within the filters and list per the search value.
     */
    updateDisplay() {
      this.isActive = false;
      this.updateFilterValue();
      this.updateListTitle();
    },

    /**
     * Updates the value within the filters this contributes to (if applicable).
     */
    updateFilterValue() {
      this.$store.dispatch('filters/setExternalValue', {
        'name': 'location',
        'value': this.search
      });
    },

    /**
     * Updates the title of the filtered list(s) this controls (if applicable).
     *
     * @param {Object} event - Javascript event object
     */
    updateListTitle() {
      const listTitleSuffixes = document.querySelectorAll(SELECTORS.LIST_TITLE_SUFFIX);

      for (let i = 0; i < listTitleSuffixes.length; i++) {
        listTitleSuffixes[i].innerText = this.search ? ` near ${this.search}` : '';
      }
    }
  }
});
